// extracted by mini-css-extract-plugin
export default {"mainView":"AddCategory_mainView__EhlSl"};